import styled from 'styled-components'
import { groupNameColor } from '../../../constants/contentfulStyle.constant'
import { LocaleCodes } from '../../../constants/localization.constants'
import ImgUtil from '../../../utils/img.utils'

const customXLBreakpoint = 1680
const customSMBreakpoint = 850

export const Navbar = styled.nav<{ $openMenu: boolean }>`
  margin: auto;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 500;
  background-color: ${({ theme }) => theme.webMktNewPalette.white};

  ${({ $openMenu }) => {
    return $openMenu
      ? `
      height: calc(100vh - 66px);
      overflow-y: scroll;
    `
      : ``
  }}
`

export const NavbarContainer = styled.div<{ $openMenu: boolean }>`
  margin: auto;
  max-width: ${customXLBreakpoint}px;
  display: grid;
  grid-template-columns: 136px repeat(2, 1fr) auto;
  align-items: center;
  justify-items: end;
  padding: 0 40px;

  .Navbar__Logo {
    justify-self: start;

    & > img {
      width: 136px;
    }
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    grid-template-columns: 110px repeat(2, 1fr) auto;
    padding: 0 32px;

    .Navbar__Logo > img {
      width: 110px;
    }
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 0;

    .Navbar__Mobile_Top {
      padding: 24px 0;

      img {
        margin-left: 24px;
      }
    }

    .Navbar__Main_Button {
      margin-right: 24px;
    }
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    padding: 0;
    grid-template-columns: 100%;
    grid-template-rows: ${({ $openMenu }: any) =>
      $openMenu ? '70px 73px auto auto' : 'auto auto auto auto'};
    position: relative;
    height: 100%;
    align-items: start;

    .Navbar__Mobile_Top {
      position: sticky;
      top: 0;
      z-index: 1000;
      width: 100%;
      background-color: ${({ theme }) => theme.webMktNewPalette.white};
      padding: 16px 0;

      img {
        margin-left: 16px;
      }
    }

    .Navbar__Main_Button {
      width: 100%;
      grid-row: 4 / 5;
      display: ${({ $openMenu }: any) => ($openMenu ? 'block' : 'none')};
      text-align: center;
      margin: 0 auto;
      padding: 24px 0;

      align-self: end;
      position: sticky;
      bottom: 0;
      background-color: ${({ theme }) => theme.webMktNewPalette.white};

      a {
        width: calc(100% - 64px);
        justify-content: center;
      }
    }
  }
`

export const NavLinksWrapper = styled.ul<{ $openMenu: boolean }>`
  justify-self: start;
  margin-left: 32px;
  display: flex;

  .Navbar__Mobile_Button {
    display: none;
  }

  .Menu-item::before {
    right: 38px;
  }

  .Menu-item.is-active {
    background-color: unset;

    .Navbar__MegaMenu {
      display: flex;
      position: absolute;
      width: 100%;
    }

    h6 {
      color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
    }
  }

  .Menu-item.is-active:before {
    border-color: ${({ theme }) => theme.webMktPalette.background.black};
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    margin-left: 20px;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    grid-row: 2 / 2;
    grid-column: 1 / 5;
    justify-self: stretch;
    justify-content: space-around;
    margin: 0;
    border-top: 1px solid ${({ theme }) => theme.webMktPalette.grayCold[25]};

    .NavLink__Active {
      .Navbar__MenuGroup > .Navbar__MegaMenu {
        display: block;
        max-height: 70vh;
        overflow-y: auto;
        top: 162px;
      }
    }

    .Navbar__Mobile_Button {
      display: block;
      padding: 16px 32px;
      width: 100%;
      text-align: left;
      text-transform: none;
    }

    .Menu-item::before {
      display: none;
    }
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    grid-row: 3 / 4;
    flex-direction: column;
    display: ${({ $openMenu }) => ($openMenu ? 'block' : 'none')};
    margin: 0;

    .NavLink__Active {
      .Navbar__MenuGroup > .Navbar__MegaMenu {
        max-height: 100%;
      }
    }

    .Menu-item::before {
      display: block;
    }
  }
`

export const NavLink = styled.li`
  .Navbar__MenuGroup {
    margin: auto 0;

    & > a {
      display: block;
      padding: 32px 12px;
      position: relative;
    }

    .Navbar__MegaMenu {
      .Navbar__MegaMenuColumn {
        &.mlevel-group {
          ${({ theme }) => theme.breakpoints.down('md')} {
            flex-direction: row;
          }
          ${({ theme }) => theme.breakpoints.down('sm')} {
            flex-direction: column;
          }
        }
        .Navbar__MegaMenuColumn-Left {
          align-self: stretch;
          background-color: ${({ theme }) => theme.webMktNewPalette.deepBlue[10]};
          max-width: 336px;

          ${({ theme }) => theme.breakpoints.down('lg')} {
            max-width: 280px;
          }
          ${({ theme }) => theme.breakpoints.down('md')} {
            max-width: 265px;
          }
          ${({ theme }) => theme.breakpoints.down('sm')} {
            max-width: 100%;
          }
          ul {
            padding-top: 32px;
            padding-bottom: 32px;
            margin-left: 24px;
            li {
              ${({ theme }) => theme.breakpoints.down('sm')} {
                margin: 8px 0;
              }
            }
          }
          .ContentfulMenuGroup {
            cursor: pointer;
            padding-left: 0;
            background-color: ${({ theme }) => theme.webMktNewPalette.deepBlue[20]};
            &:nth-child(2) {
              margin-bottom: 24px;
            }
            ${({ theme }) => theme.breakpoints.down('sm')} {
              display: none;
            }
            .Navbar__Section_Container {
              padding: 16px 32px;
              margin-left: 0;
              margin-right: 0;
              ${({ theme }) => theme.breakpoints.down('sm')} {
                padding: 0;
              }
            }
            &:hover,
            &.is-active {
              background-color: ${({ theme }) => theme.webMktNewPalette.background.light.default};
            }
            .Navbar__Section_Container {
              ${({ theme }) => theme.breakpoints.down('md')} {
                grid-template-columns: repeat(1, 1fr);
                grid-column-gap: 0;
                margin-right: 0;
              }
            }
            .Navbar__Section_Content {
              .Navbar__Section_Name {
                font-family: Inter, sans-serif;
                font-size: 20px;
                font-weight: 600;
                letter-spacing: 0px;
                line-height: 24px;
                text-transform: none;
                margin-top: 0px;
                margin-bottom: 4px;
                letter-spacing: -1px;
                ${({ theme }) => theme.breakpoints.down('md')} {
                  font-size: 14px;
                }
              }
              .Navbar__Section_Description {
                margin-bottom: 0px;
              }
            }
          }
          .ContentfulTopicIconLink {
            .Navbar__IconLink_Header {
              padding: 8px 24px;
              display: flex;
              align-items: flex-start;
              gap: 10px;
              img {
                margin-top: 4px;
              }
              p {
                display: flex;
                align-items: center;
                margin: 0;
                line-height: 24px;

                ${({ theme }) => theme.breakpoints.down('md')} {
                  font-size: 14px;
                }

                a {
                  color: ${({ theme }) => theme.webMktNewPalette.black};

                  &:hover {
                    color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
                  }
                }

                span {
                  background-color: ${({ theme }) => theme.webMktNewPalette.orange[50]};
                  color: ${({ theme }) => theme.webMktNewPalette.white};
                  font-weight: 700;
                  font-size: 10px;
                  padding: 0px 4px;
                  border-radius: 2px;
                  text-transform: uppercase;
                  letter-spacing: 1px;
                  margin-left: 5px;
                  display: inline-block;
                  line-height: 16px;
                  -webkit-text-stroke: 0px;
                  letter-spacing: normal;
                }
              }
              &:hover {
                p {
                  color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
                }
              }
              ${({ theme }) => theme.breakpoints.down('sm')} {
                padding: 0;
                margin: auto 24px;
              }
            }
            ${({ theme }) => theme.breakpoints.down('md')} {
              border-bottom: none;
            }
          }

          ${({ theme }) => theme.breakpoints.down('sm')} {
            order: 1;
            ul {
              padding-bottom: 16px;
              padding-top: 16px;
              margin-left: 8px;
            }
          }
        }
        .Navbar__MegaMenuColumn-Right {
          align-self: stretch;
          background-color: ${({ theme }) => theme.webMktNewPalette.background.light.default};
          .ContentfulMenuGroup {
            ${({ theme }) => theme.breakpoints.down('sm')} {
              margin: 0 32px 0;
              width: calc(100% - 64px);
              &:last-child {
                border-bottom: none;
              }
              .Navbar__Section_Container {
                margin: 0;
                padding-left: 0;
                padding-right: 0;
              }
            }
            ${({ theme }) => theme.breakpoints.down('md')} {
              margin: 0 32px 0;
            }
          }
          .Navbar__Sub_Accordion {
            &.NavLink__Active:first-child {
              .Navbar__Sub_Accordion_Item {
                .Navbar__Sub_Accordion_Name {
                  &:before {
                    content: '-';
                  }
                }
              }
            }
            .Navbar__Sub_Accordion_Item {
              display: none;
              ${({ theme }) => theme.breakpoints.down('sm')} {
                display: block;
                padding: 16px 32px;
                text-align: left;
                text-transform: none;
                background-color: ${({ theme }) => theme.webMktNewPalette.deepBlue[10]};
                border-bottom: 1px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[20]};
              }

              .Navbar__Sub_Accordion_Name {
                position: relative;

                &:before {
                  content: '+';
                  position: absolute;
                  right: 0;
                  width: 20px;
                  height: 20px;
                  font-size: 24px;
                  font-weight: 400;
                  text-align: center;
                }
              }

              &.is-active {
                .Navbar__Sub_Accordion_Name {
                  &:before {
                    content: '-';
                  }
                }
              }
            }
            .Navbar__Sub_Accordion_MenuGroup {
              display: none;
              .Right-Section {
                background-color: ${({ theme }) => theme.webMktNewPalette.deepBlue[10]};
                min-width: 336px;

                ${({ theme }) => theme.breakpoints.down('lg')} {
                  min-width: 277px;
                  max-width: 324px;
                }
                ${({ theme }) => theme.breakpoints.down('md')} {
                  min-width: 205px;
                  max-width: 324px;
                }
                ${({ theme }) => theme.breakpoints.down('sm')} {
                  display: none;
                }
                .menu-tab-content {
                  li {
                    background-color: ${({ theme }) => theme.webMktNewPalette.deepBlue[10]};
                    padding: 0;
                  }
                }
              }
              .Navbar__Sub_Accordion_Desc {
                display: none;
                padding: 16px 32px;
                ${({ theme }) => theme.breakpoints.down('sm')} {
                  display: block;
                }
              }
            }
            &.NavLink__Active {
              display: block;
              height: 100%;
              .Navbar__Sub_Accordion_MenuGroup {
                display: flex;
                height: 100%;
                ${({ theme }) => theme.breakpoints.down('sm')} {
                  flex-direction: column;
                }
              }
            }
          }

          ul {
            li {
              background-color: ${({ theme }) => theme.webMktNewPalette.background.light.default};
              &:after {
                border-left: 1px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[20]};
              }
              &:first-child {
                &:after {
                  border-left: none;
                }
              }
              ${({ theme }) => theme.breakpoints.down('md')} {
                &:after {
                  border-left: none;
                }
              }
            }
          }
        }

        &.slevel-group {
          color: #cc0000;
          .Navbar__MegaMenuColumn-Left {
            flex: 1;
            order: 0;
            > ul {
              margin-left: 0;
            }
            .ContentfulMenuGroup {
              background-color: transparent;
              display: block;
              border-bottom: none;

              .Navbar__Section_Container {
                margin: auto 32px;
                grid-template-columns: repeat(3, 1fr);
                ${({ theme }) => theme.breakpoints.down('xs')} {
                  grid-template-columns: repeat(1, 1fr);
                }
              }
            }
          }
          .Navbar__MegaMenuColumn-Right {
            display: flex;
            flex: 1;

            .Left-Section {
              flex: 1;
              ul {
                display: flex;
                ${({ theme }) => theme.breakpoints.down('sm')} {
                  display: block;
                }
                ${({ theme }) => theme.breakpoints.down('xs')} {
                  flex-direction: column;
                }
              }
            }

            .Right-Section {
              flex: 1;
              max-width: 336px;
              background-color: ${({ theme }) => theme.webMktNewPalette.deepBlue[10]};
              ${({ theme }) => theme.breakpoints.down('sm')} {
                display: none;
              }
              .ContentfulComponentMainNavBanner {
                background-color: ${({ theme }) => theme.webMktNewPalette.deepBlue[10]};
              }
            }
          }
        }
      }
    }

    &:hover {
      & > a::after {
        content: '';
        position: absolute;
        left: 50%;
        top: 89px;
        z-index: 600;
        transform: translateX(-50%);
        border-width: 8px 9px;
        border-style: solid;
        border-color: transparent;
        border-top-color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
      }

      .Navbar__MegaMenu {
        display: flex;
      }

      h6 {
        color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
      }
    }

    &.open {
      .Navbar__MegaMenu {
        display: flex;
      }
    }
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    .Navbar__MenuGroup {
      h6 {
        ${({ theme }) => theme.webMktTypography.typography.heading6.md};
      }

      &:hover {
        & > a::after {
          top: 85px;
        }
      }
    }
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    .Navbar__MenuGroup {
      & > a {
        padding: 20px 12px;
        display: none;
      }

      &:hover {
        & > a::after {
          top: 60px;
        }
      }
    }
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    border-bottom: 1px solid ${({ theme }) => theme.webMktPalette.grayCold[25]};
  }
`

export const MegaMenu = styled.div<{
  $direction: string
  $numOfGrayColumns: number
  $maxLength: number
  $doesMainNavBannerExist: boolean
}>`
  position: absolute;
  left: 0;
  background-color: ${({ theme }) => theme.webMktNewPalette.background.light.default};
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.webMktPalette.grayCold[25]};
  box-shadow: 0px 15px 15px ${({ theme }) => theme.webMktNewPalette.alphaBlack[20]};
  display: none;
  overflow-y: auto;

  .MegaMenu__Side {
    width: 100%;
    background-color: ${({ theme }) => theme.webMktNewPalette.deepBlue[10]};
  }

  ${({ theme, $direction, $numOfGrayColumns, $maxLength, $doesMainNavBannerExist }: any) => {
    let backgroundStyle = ``

    if ($numOfGrayColumns >= $maxLength) {
      return `
        .MegaMenu__Side:last-child {
          background-color: ${theme.webMktNewPalette.deepBlue[10]};
        }

        .MegaMenu__Side:first-child {
          background-color: ${theme.webMktNewPalette.deepBlue[10]};
        }
      `
    } else {
      if ($direction === 'Right') {
        backgroundStyle += `
          .MegaMenu__Side:last-child {
            background-color: ${theme.webMktNewPalette.deepBlue[10]};
          }
        `
      }

      if ($direction === 'Left') {
        backgroundStyle += `
          .MegaMenu__Side:first-child {
            background-color: ${theme.webMktNewPalette.deepBlue[10]};
          }
        `
      }
    }

    if ($doesMainNavBannerExist) {
      backgroundStyle += `
        .MegaMenu__Side:last-child {
          background-color: ${theme.webMktNewPalette.deepBlue[10]};
        }
      `
    }

    return backgroundStyle
  }}

  @media (max-width: ${customXLBreakpoint}px) {
    .MegaMenu__Side {
      display: none;
    }
  }

  ${({ theme }) => theme.breakpoints.down('lg')} {
    max-height: 84vh;
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    position: static;
    box-shadow: unset;
  }
`

export const MegaMenuContainer = styled.ul`
  max-width: ${customXLBreakpoint}px;
  min-width: ${customXLBreakpoint}px;
  margin: auto;
  display: flex;
  align-items: start;
  width: 100%;

  @media (max-width: ${customXLBreakpoint}px) {
    min-width: auto;

    .MegaMenu__Side {
      display: none;
    }
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    align-items: stretch;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    flex-direction: column;
    width: 100%;
  }

  .menu-tab-content {
    display: flex;

    ${({ theme }) => theme.breakpoints.down('md')} {
      flex-direction: row;
      display: flex;
    }
    ${({ theme }) => theme.breakpoints.down('sm')} {
      flex-direction: column;
    }
  }

  .Navbar__Sub_Accordion_All_Link {
    text-align: center;
    border-top: 1px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[20]};
    padding: 24px 24px 32px;
    a {
      color: ${({ theme }) => theme.webMktNewPalette.black};
      font-weight: 400;
      &:hover {
        color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
      }
    }
  }
`

export const MegaMenuSection = styled.li<{
  $textColor: string
  $numOfGrayColumns: number
  $direction: string
  $position: number
  $maxLength: number
  $doesContentExist: boolean
  $hasIconLink: boolean
  $doesMainNavBannerExist: boolean
}>`
  flex: 1;
  position: relative;
  width: 100%;
  ${({ theme, $doesMainNavBannerExist, $position, $maxLength }) => {
    return $doesMainNavBannerExist && $position === $maxLength
      ? `
      display: flex;
      align-self: stretch;
      background-color: ${theme.webMktNewPalette.deepBlue[10]};
    `
      : ``
  }}

  .Navbar__Section_Container {
    padding: 32px 10%;
    margin-left: 24px;

    .Navbar__Section_Name {
      letter-spacing: 1px;
      margin-bottom: 12px;
      font-weight: 500;
      color: ${({ $textColor }: any) => groupNameColor($textColor)};
      text-transform: uppercase;
    }

    .Navbar__Section_Description {
      letter-spacing: 0.3px;
      margin-bottom: 16px;
      line-height: 18px;
      color: ${({ theme }) => theme.webMktNewPalette.deepBlue[55]};
    }
  }

  &::after {
    content: ' ';
    position: absolute;
    border-left: 1px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[20]};
    top: 50%;
    transform: translateY(-50%);
    height: calc(100% - 64px);
  }

  &:first-child::after {
    border-left: none;
  }

  ${({ theme, $numOfGrayColumns, $direction, $position, $maxLength }: any) => {
    let sectionStyle = ``

    if ($direction === 'Left') {
      if ($position <= $numOfGrayColumns) {
        sectionStyle += `
          background-color: ${theme.webMktNewPalette.deepBlue[10]};
          align-self: stretch;
        `
      } else if ($position - 1 === $numOfGrayColumns) {
        sectionStyle += `
          &::after {
            border-left: none;
          }
        `
      }
    } else if ($direction === 'Right') {
      if ($position - 1 + $numOfGrayColumns === $maxLength) {
        sectionStyle += `
          &::after {
            border-left: none;
          }
        `
      }

      if ($position - 1 + $numOfGrayColumns >= $maxLength) {
        sectionStyle += `
          background-color: ${theme.webMktNewPalette.deepBlue[10]};
          align-self: stretch;
        `
      }
    } else {
      return ``
    }

    return sectionStyle
  }}

  ${({ theme }) => theme.breakpoints.down('lg')} {
    .Navbar__Section_Container {
      padding: 32px 12px;
      margin: auto 20px;
    }

    &:first-child {
      padding-left: 12px;
    }

    &:last-child {
      padding-right: 12px;
    }
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    .Navbar__Section_Container {
      padding: 32px 6px;
      margin: auto 6px;

      .Navbar__Section_Name {
        font-size: ${({ theme }) => theme.typography.fontSize}px;
      }
    }

    &::after {
      border-left: none;
    }

    &:first-child {
      padding-left: 22px;
    }

    &:nth-child(2) {
      padding-left: 12px;
    }

    &:last-child {
      padding-right: 10px;
    }
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    border-bottom: 1px solid ${({ theme }) => theme.webMktPalette.grayCold[25]};

    &:first-child,
    &:nth-child(2) {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
    }

    .Navbar__Section_Container {
      margin: auto 24px;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: auto auto;
      grid-column-gap: 24px;

      .Navbar__Section_Content {
        grid-row: 1 / 2;
        grid-column: 1 / 2;
      }

      .SubList__Left,
      .SubList__Right {
        grid-row: 1 / 3;
      }

      .SubList__Left {
        margin-left: ${({ $doesContentExist }) => ($doesContentExist ? '15%' : 0)};
      }

      .SubList__Right {
        margin-left: ${({ $doesContentExist }) => ($doesContentExist ? 0 : '15%')};
      }
    }
  }

  @media (max-width: ${customSMBreakpoint}px) {
    .Navbar__Section_Container {
      .SubList__Left {
        margin-left: ${({ $doesContentExist }) => ($doesContentExist ? '5%' : 0)};
      }

      .SubList__Right {
        margin-left: ${({ $doesContentExist }) => ($doesContentExist ? 0 : '5%')};
      }
    }
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    border-bottom: none;
    background-color: ${({ theme }) => theme.webMktNewPalette.deepBlue[10]};

    .Navbar__Section_Container {
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: auto auto;
      grid-column-gap: 20px;
      padding: 10px 0;

      .Navbar__Section_Content {
        grid-row: 1 / 2;
        grid-column: 1 / 3;
      }

      .Navbar__Section_Name {
        display: flex;
        align-items: center;

        &:after {
          content: ' ';
          height: 1px;
          margin-left: 24px;
          background: ${({ theme }) => theme.webMktNewPalette.black};
          flex: 2;
          background-color: ${({ theme }) => theme.webMktNewPalette.black};
          opacity: 0.1;
        }
      }

      .SubList__Left,
      .SubList__Right {
        margin-left: 0;
      }

      ${({ $hasIconLink }) => {
        return $hasIconLink
          ? `
          .SubList__Left {
            grid-column: 1 / 3;
            grid-row: 2 / 3;
          }
    
          .SubList__Right {
            grid-column: 1 / 3;
            grid-row: 3 / 4;
          }
        `
          : `
          .SubList__Left {
            grid-row: 2 / 3;
          }
    
          .SubList__Right {
            grid-row: 2 / 3;
          }
        `
      }}
    }
  }
`

export const SubListItem = styled.div<{ $subListLength: number; $isThereDescription: boolean }>`
  a {
    p {
      padding: 6px 0;
    }

    &:hover {
      p {
        color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
      }

      .Navbar__IconLink_Caption {
        color: ${({ theme }) => theme.webMktNewPalette.deepBlue[55]};
      }
    }
  }

  .Navbar__IconLink_Header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: ${({ $isThereDescription }) => ($isThereDescription ? '0' : '6px')};

    & > p {
      padding: 0;
      display: flex;
      align-items: center;
      span {
        background-color: ${({ theme }) => theme.webMktNewPalette.orange[50]};
        color: ${({ theme }) => theme.webMktNewPalette.white};
        font-weight: 700;
        font-size: 10px;
        padding: 0px 4px;
        border-radius: 2px;
        text-transform: uppercase;
        letter-spacing: 1px;
        margin-left: 5px;
        display: inline-block;
        line-height: 16px;
        -webkit-text-stroke: 0px;
        letter-spacing: normal;
      }
    }
  }

  .Navbar__IconLink_Caption {
    color: ${({ theme }) => theme.webMktNewPalette.deepBlue[55]};
  }

  .Navbar__IconLink_Caption {
    margin-top: 0;
    padding-top: 3px;
    margin-bottom: 5px;
    letter-spacing: 0.3px;
  }

  .Navbar__HighlightedLink {
    color: black;
    margin-top: 9px;

    .CTA__Arrow-Container {
      margin-left: 8px;

      &::before {
        font-size: 18px;
      }
    }

    span {
      font-size: ${({ theme }) => theme.typography.fontSize}px;
    }
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    .Navbar__SubList_IconLink > div > p,
    .Navbar__SubList_Cta > p {
      font-size: ${({ theme }) => theme.typography.fontSize}px;
    }

    .Navbar__IconLink_Caption {
      width: 90%;
    }
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    .Navbar__HighlightedLink {
      margin: ${({ $subListLength }) => ($subListLength === 1 ? '5px 0' : '0')};
      padding: ${({ $subListLength }) => ($subListLength === 1 ? '6px 0' : '3px 0')};
    }
  }
`

export const IconLinksSection = styled.div<{ $openMenu: boolean; $langCode: string }>`
  display: flex;
  text-decoration: none;
  margin-right: 36px;

  .Navbar__TopHatLinks_Wrapper {
    display: flex;
    align-items: center;
    gap: 24px;
    padding-left: 24px;
    border-left-style: solid;
    border-left-color: ${({ theme }) => theme.webMktPalette.grayCold[25]};
    border-left-width: ${({ $langCode }) =>
      $langCode !== LocaleCodes.CHINESE.code ? `1px` : `0px`};

    li:hover {
      p,
      img {
        color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
      }
    }

    a {
      display: flex;
      align-items: center;
      gap: 13px;

      p {
        font-weight: 700;
      }
    }
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    gap: 35px;

    p {
      display: none;
    }

    .Navbar__TopHatLinks_Wrapper {
      gap: 33px;
      padding-left: 0;
      border-left: none;
    }
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    grid-column: 3 / 4;
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    grid-row: 2 / 3;
    grid-column: 1 / 2;
    display: ${({ $openMenu }) => ($openMenu ? 'block' : 'none')};
    text-align: center;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.webMktPalette.grayCold[25]};
    background-color: ${({ theme }) => theme.webMktNewPalette.deepBlue[10]};
    padding: 18px 0;
    margin-right: 0;

    li {
      display: inline-block;
      flex: 1;
    }

    .Navbar__TopHatLinks_Wrapper {
      gap: 0;

      li a {
        display: flex;
        justify-content: center;
        border-left: 1px solid ${({ theme }) => theme.webMktPalette.grayCold[25]};
        padding: 6px 0;
      }

      li:first-child a {
        border-left: none;
      }

      p {
        display: block;
      }
    }
  }
`

export const HeaderSearch = styled.div`
  height: 22px;
  width: 22px;
  margin-right: 24px;

  .MainHeader-gcsSearchButton.searchIcon {
    svg {
      width: 22px;
      height: 22px;
      margin: auto;
      transform: scale(1) translateZ(0);
      transform-origin: 33% 33%;
      transition: transform 0.2s ease;

      &:hover {
        fill: ${({ theme }) => theme.webMktPalette.icon.blueLight};
        transform: scale(1.2);
        transition: all 0.2s ease-out;
      }
    }
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    margin-right: 0;
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    display: none;
  }
`

export const ResponsiveIcon = styled.div<{ $openMenu: boolean }>`
  display: none;
  position: absolute;
  top: 21px;
  right: 16px;
  cursor: pointer;

  .Navbar__Hamburger {
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: space-evenly;
    flex-flow: column nowrap;

    div {
      width: 20px;
      height: 2px;
      background-color: ${({ theme }) => theme.webMktNewPalette.black};
    }
  }

  ${({ theme, $openMenu }) => {
    return $openMenu
      ? `
      width: 80px;

      &:hover {
        p {
          color: ${theme.webMktNewPalette.action.light.primary};
        }
      }
      
      .Navbar__Hamburger {
        position: relative;
        left: 55px;

        div {
          width: 24px;
        }

        div:nth-child(1) {
          transform: translate(-1px, 7px) rotate(-315deg);
          top: 20px;
        }
    
        div:nth-child(2) {
          opacity: 0;
        }
    
        div:nth-child(3) {
          transform: translate(-1px, -6px) rotate(-225deg);
        }
      }
    `
      : `
    `
  }}

  ${({ theme }) => theme.breakpoints.down('xs')} {
    display: block;
  }
`

export const ButterBarStyles = styled.div<{ $backgroundUrl: string }>`
  background-image: url(${({ $backgroundUrl }) => ImgUtil.getResizedImageUrl($backgroundUrl, '')});
  background-position: center;
  position: relative;
  background-size: 100%;

  ${({ theme }) => theme.breakpoints.down('xs')} {
    text-align: center;
    padding: 3px 0 6px;
  }
  .butterBar__link {
    display: none;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    min-height: 62px;
    padding: 0 16px;

    ${({ theme }) => theme.breakpoints.down('xs')} {
      flex-direction: column;
      height: auto;
    }
    .row__firstline {
      ${({ theme }) => theme.breakpoints.down('xs')} {
        display: flex;
        align-items: center;
        padding-bottom: 5px;
      }
      .firstImage {
        height: 100%;
        box-sizing: border-box;
        padding: 0;
        height: 62px;
        ${({ theme }) => theme.breakpoints.down('xs')} {
          height: 40px;
          padding: 0;
        }
      }
      p {
        display: none;
        ${({ theme }) => theme.breakpoints.down('xs')} {
          display: block;
          font-size: 16px;
          line-height: 18px;
          font-weight: 700;
          color: ${({ theme }) => theme.webMktNewPalette.black};
          letter-spacing: -0.4px;
          padding-left: 3px;
        }
      }
    }
    .countDown__butterBar {
      display: flex;
      align-items: center;

      ${({ theme }) => theme.breakpoints.down('xs')} {
        padding: 0;
        height: auto;
      }
      .secondImage {
        padding: 0 19px 0 0px;
        height: 62px;
        ${({ theme }) => theme.breakpoints.down('lg')} {
          padding: 0 9px 0 0px;
        }
        ${({ theme }) => theme.breakpoints.down('xs')} {
          padding: 0;
        }
      }
      .ticketText p {
        color: ${({ theme }) => theme.webMktNewPaletteblack};
        padding-left: 8px;
        font-size: 24px;
        font-weight: 600;
        line-height: 30px;
        letter-spacing: -1px;
        padding-right: 8px;
        ${({ theme }) => theme.breakpoints.down('xs')} {
          padding: 0;
        }
      }
    }
    .cta__link {
      display: flex;
      color: ${({ theme }) => theme.webMktNewPalette.orange[50]};
      font-weight: 700;
      :hover {
        color: ${({ theme }) => theme.webMktNewPalette.orange[50]};
      }
      ${({ theme }) => theme.breakpoints.down('sm')} {
        min-width: 142px;
        display: none;
      }
      ${({ theme }) => theme.breakpoints.down('xs')} {
      }
      span {
        padding-right: 10px;
      }
      svg {
        path {
          fill: ${({ theme }) => theme.webMktNewPalette.orange[50]};
        }
      }
    }
  }
  .active__Butterbar {
    display: flex;
  }
  .butterbar-countdown {
    display: flex;
  }
  .butterbar-pricing {
    display: none;
  }
`
export const CountDownStyles = styled.div<{}>`
  .countDownClock {
    display: flex;
    align-items: center;
    height: 100%;

    animation: fadeIn 2s forwards;
    font-family: inter-black;
    padding-right: 8px;

    ${({ theme }) => theme.breakpoints.down('xs')} {
      padding-right: 0px;
    }

    .clockIntro {
      font-family: Inter-black, sans-serif;
      font-size: 16px;
      font-weight: 700;
      letter-spacing: -1px;
      line-height: 20px;
      color: ${({ theme }) => theme.webMktNewPalette.black};
      padding-left: 8px;

      ${({ theme }) => theme.breakpoints.down('xs')} {
        display: none;
      }
    }
    .countText {
      padding-left: 12px;

      color: ${({ theme }) => theme.webMktNewPalette.black};
      ${({ theme }) => theme.breakpoints.down('xs')} {
        padding-left: 3px;
      }

      span {
        font-family: Inter-black, sans-serif;
        font-weight: 900;
        display: inline-block;
        font-size: 28px;
        line-height: 48px;
        letter-spacing: -1px;
        ${({ theme }) => theme.breakpoints.down('xs')} {
          min-width: 38px;
          font-size: 32px;
          line-height: 20px;
        }
      }
      sup {
        font-family: Inter-black, sans-serif;
        font-size: 14px;
        line-height: 24px;
        font-weight: 700;
        padding: 0px 0 0px 2px;
        vertical-align: middle;
        letter-spacing: normal;
        color: ${({ theme }) => theme.webMktNewPalette.black};
        ${({ theme }) => theme.breakpoints.down('xs')} {
          font-size: 10px;
          line-height: 16px;
        }
      }
    }
    .activeCount {
      color: ${({ theme }) => theme.webMktNewPaletteblack};
      padding-left: 8px;
    }
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    25% {
      opacity: 0;
    }
    50% {
      opacity: 0;
    }
    75% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`
